import auth from '@/service/AuthService';

export default function autGuard(to, from, next) {
  if (to.path === '/login' || to.meta.authNotRequired) {
    next();
    return;
  }

  auth.isLoggedIn()
    .then((loggedIn) => {
      if (loggedIn) {
        next()
      } else {
        const route = { path: '/login' }
        if (to.fullPath !== '/') {
          route.query = { redirect: encodeURIComponent(to.fullPath) }
        }
        next(route);
      }
    })
}



// WEBPACK FOOTER //
// ./src/router/authGuard.js